<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Languages</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a href="/admin">Home</a></li>
                    <li class="breadcrumb-item active">Languages</li>
                </ol>
            </div>
        </div>
    </div>
    <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
    <!-- Default box -->
    <div class="container-fluid">
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Language List <button class="btn btn-primary pull-right" (click)="openSaveModal()">+Add New</button></h3>

               
            </div>
            <div class="card-body">
              


              
                                 
                                  <table class="table table-bordered">
                                    <thead>
                                    <tr>
                  
                                      <th>Icon</th>
                                      <th>Name</th>
                                      <th>Code (tr-TR, en-EN,en-US vs)</th>
                                      <th>ApiCode (tatoeba api language code for sample sentence for ex: Turkish=tur, English=eng )</th>
                                   
                                      <th></th>
                                    </tr>
                                    </thead>  
                                    <tbody>
                                      <tr *ngFor="let lang of languages" >
                                       
                                        <td >  <img src="{{lang.iconUrl}}"></td>
                                        <td>{{lang.name}}</td>
                                        <td>{{lang.code}}</td>
                                        <td>{{lang.apicode}}</td>
                                    
                                    
                                        <td> 
                                           <button class="btn btn-icon btn-pure success" (click)="detail(lang)"><i class="fa fa-edit"></i> </button>
                                           |  
                                           <button class="btn btn-icon btn-pure danger" (click)="delete(lang.id)"><i class="fa fa-trash"></i></button></td>
                                    
                                      </tr>
                                    </tbody>
                                  
                                  </table>
                              



            </div>
            <!-- /.card-body -->
            <div class="card-footer"></div>
            <!-- /.card-footer-->
        </div>
    </div>
    <!-- /.card -->
</section>
<!-- /.content -->
